import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const GET_FEEDBACK_QUERY = gql`
  query getFeedback($id: ID!) {
    getInspection(id: $id) {
      id
      source
      feedback {
        casecheck
        modelerror
        exiferror
      }
    }
  }
`;

const UPDATE_FEEDBACK_MUTATION = gql`
  mutation updateFeedback($input: UpdateFeedbackInput!) {
    updateInspectionFeedback(input: $input) {
      id
      source
      feedback {
        casecheck
        modelerror
        exiferror
      }
    }
  }
`;

function InspectionEditableFeedback({ id }) {
  const { t } = useTranslation();
  const { error, data } = useQuery(GET_FEEDBACK_QUERY, {
    variables: { id }
  });
  const [updateFeedback, { loading: updateFeedbackLoading }] = useMutation(
    UPDATE_FEEDBACK_MUTATION
  );
  const { feedback } = data?.getInspection || {};

  // handlers
  const handleFeedbackToggleClick = async name => {
    const newFeedback = {
      ...feedback,
      [name]: !feedback[name]
    };
    // eslint-disable-next-line no-underscore-dangle
    delete newFeedback.__typename;
    delete newFeedback.undefined;
    const input = {
      id,
      source: data?.getInspection?.source,
      ...newFeedback
    };
    try {
      await updateFeedback({ variables: { input } });
      toast.success(t('inspection.update_success'));
    } catch (err) {
      toast.success(t('inspection.update_failure', { error }));
    }
  };

  return (
    <div>
      <Button
        color={feedback.casecheck ? 'success' : 'secondary'}
        type="button"
        name="casecheck"
        onClick={() => handleFeedbackToggleClick('casecheck')}
        disabled={updateFeedbackLoading}
      >
        <span className="text-uppercase">{t('case.feedback.checked')}</span>
      </Button>
      <Button
        color={feedback.modelerror ? 'danger' : 'secondary'}
        type="button"
        name="modelerror"
        onClick={() => handleFeedbackToggleClick('modelerror')}
        disabled={updateFeedbackLoading}
      >
        <span className="text-uppercase">{t('case.feedback.model_error')}</span>
      </Button>
    </div>
  );
}

InspectionEditableFeedback.propTypes = {
  id: PropTypes.string.isRequired
};

export default InspectionEditableFeedback;
